<template lang="html">
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Upload de Arquivos"
    type-modal="upload_file_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="save()">

        <d-form-row>
          <d-col class="form-group">
            <label for="feName" class="m-0 p-0">Nome</label>
            <d-form-input type="text" v-model="model.name" id="feName" placeholder="Nome" />
          </d-col>
        </d-form-row>

        <d-form-row>
          <d-col class="form-group">
            <label for="feName" class="m-0 p-0">Arquivo</label>
            <input type="file" class="form-control upload" @change="choseFile($event)">
          </d-col>
        </d-form-row>

      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="cancel()"
        class="btn btn-sm btn-secondary mr-3"
      >Cancelar</d-button>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Salvar</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import ProjectService from '_services/rest/modules/project';
import { _SAVE_PROJECT_FILE_SUCCESS_ } from '../ProjectModel';

const MODEL = {
  id: '',
  name: '',
  file: '',
};

export default {
  name: 'upload-project-file',
  components: {
    ModalTemplate,
  },
  props: {
    projectId: {
      type: Number,
      required: true,
    },
  },
  computed: {
  },
  data() {
    return {
      model: { ...MODEL },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getGroups',
    ]),
    cancel() {
      this.setToggle({ type: 'upload_file_modal', bool: false });
    },
    choseFile(event) {
      const [file] = event.target.files;
      this.model.file = file;
    },
    save() {
      this.cancel();
      this.model.id = this.projectId;
      ProjectService.uploadFile(this.model)
        .then(() => {
          Events.$emit(_SAVE_PROJECT_FILE_SUCCESS_);
          this.model = { ...MODEL };
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>
